import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Expense } from '@core/model/expense.model';
import { AuthenticationService, ExpenseService } from '@app/core';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-expense-create',
  templateUrl: './expense-create.component.html',
  styleUrls: ['./expense-create.component.css']
})
export class ExpenseCreateComponent implements OnInit {
  expenseForm: FormGroup;
  private user_id: number;
  currentUserSubscription: Subscription;
  @Input() title: string;
  @Input() estado: boolean;
  @Input() expense_id: string;
  isLoading = false;

  constructor(
    private formBuilder: FormBuilder,
    private expenseService: ExpenseService,
    private authService: AuthenticationService,
    private router: Router,
    public activeModal: NgbActiveModal
  ) {
    // sacamos el id den quien esta logueado
    this.currentUserSubscription = this.authService.currentUser.subscribe(
      user => {
        // console.log(data.data.user.id);
        this.user_id = user.data.user.id;
        // this.username = this.currentUser.data.user.username;
      }
    );
  }

  ngOnInit() {
    this.createForm();
    if (this.estado === true) {
      this.expenseService.getById(this.expense_id).subscribe(
        data => {
          this.expenseForm.setValue({
            monto: data.monto,
            descripcion: data.descripcion
          });
        },
        error1 => console.log(error1)
      );
    }
  }

  createForm() {
    this.expenseForm = this.formBuilder.group({
      monto: ['', [Validators.required]],
      descripcion: ['', [Validators.required, Validators.minLength(5)]]
    });
  }

  registerExpense() {
    const newExpense = new Expense();
    newExpense.monto = this.expenseForm.value.monto;
    newExpense.descripcion = this.expenseForm.value.descripcion;
    newExpense.user_id = this.user_id;
    if (this.estado === true) {
      this.expenseService.update(this.expense_id, newExpense).subscribe(
        data => {
          Swal.fire(data);
          this.expenseForm.reset();
          this.activeModal.close(data);
        },
        error1 => {
          console.log(error1);
          Swal.fire(error1.error);
        }
      );
    } else {
      this.expenseService.create(newExpense).subscribe(
        data => {
          Swal.fire(data);
          this.expenseForm.reset();
          this.activeModal.close(data);
        },
        error1 => {
          console.log(error1);
          Swal.fire(error1.error);
        }
      );
    }
  }
}
